import { render, staticRenderFns } from "./parametre.vue?vue&type=template&id=ecbef696&scoped=true&"
import script from "./parametre.vue?vue&type=script&lang=js&"
export * from "./parametre.vue?vue&type=script&lang=js&"
import style0 from "./parametre.vue?vue&type=style&index=0&id=ecbef696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbef696",
  null
  
)

export default component.exports